<div matTooltip="{{tooltip}}" [ngSwitch]="status">

  <div *ngSwitchCase="1">
    <mat-icon class="mdi mdi-content-save blue size"></mat-icon>
  </div>

  <div *ngSwitchCase="2">
    <mat-icon class="mdi mdi-alarm-check blue size"></mat-icon>
  </div>

  <div *ngSwitchCase="3">
    <i class="material-icons blue">shopping_basket</i>
  </div>

  <div *ngSwitchCase="4">
    <mat-icon class="mdi mdi-close-circle red size"></mat-icon>
  </div>

  <div *ngSwitchCase="5">
    <i class="material-icons green">shopping_basket</i>
  </div>

  <div *ngSwitchCase="6">
    <i class="material-icons red">shopping_basket</i>
  </div>

  <div *ngSwitchCase="7">
    <i class="material-icons">edit</i>
  </div>

  <div *ngSwitchCase="8">
    <mat-icon class="mdi mdi-truck-delivery yellow size"></mat-icon>
  </div>

  <div *ngSwitchCase="9">
    <mat-icon class="mdi mdi-truck-delivery purple size"></mat-icon>
  </div>

  <div *ngSwitchCase="10">
    <i class="material-icons green">shopping_basket</i>
  </div>

  <!-- Deleted -->
  <div *ngSwitchCase="11">
    <i class="material-icons red">delete_forever</i>
  </div>

  <!-- Not delivered -->
  <div *ngSwitchCase="12">
    <mat-icon class="mdi mdi-truck-delivery red size"></mat-icon>
  </div>

</div>
